import pageTitle from 'ember-page-title/helpers/page-title';
import { t } from 'ember-intl';

<template>
  {{pageTitle (t "recommendations_estimator.forgiveness_estimator")}}
  {{outlet}}
</template>
